import type React from 'react';

import AnalyticsIntegrationsProvider, {
  type AnalyticsIntegrationsProviderProps,
} from '../AnalyticsIntegrationsProvider';
import AnalyticsProxyProvider, {
  type AnalyticsProxyProviderProps,
} from '../AnalyticsProxyProvider';

export type AnalyticsProviderProps = AnalyticsIntegrationsProviderProps &
  AnalyticsProxyProviderProps;

const AnalyticsProvider: React.FC<React.PropsWithChildren<AnalyticsProviderProps>> = ({
  children,
  autoInitialize,
  customIntegrations,
  fullStory,
  settings,
}) => (
  <AnalyticsIntegrationsProvider customIntegrations={customIntegrations} fullStory={fullStory}>
    <AnalyticsProxyProvider settings={settings} autoInitialize={autoInitialize}>
      {children}
    </AnalyticsProxyProvider>
  </AnalyticsIntegrationsProvider>
);

export default AnalyticsProvider;
